import { render } from "./CreateOwner.vue?vue&type=template&id=85f4ae54&scoped=true"
import script from "./CreateOwner.vue?vue&type=script&lang=js"
export * from "./CreateOwner.vue?vue&type=script&lang=js"

import "./CreateOwner.vue?vue&type=style&index=0&id=85f4ae54&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f4ae54"]])

export default __exports__